import Item from "../../../Item";

import { Stack, Typography, Chip } from "@mui/material";
export default function NervosCranianos({ data }) {
  return (
    <Stack>
      <Stack className="template-grid column-3">
        <Item label="Reflexo fotomotor" text={data.reflexoFotomotor} />
        <Item label="Fundo de olho - Papiledema" text={data.papilederma} />
        <Item
          label="Motricidade ocular - Oftalmoparesia"
          text={data.motricidadeOcular}
        />
        <Item label="Ptose palpebral" text={data.ptosePalpebral} />
        <Item label="Reflexo nauseoso" text={data.reflexoNauseoso} />
      </Stack>
      <Typography component="p" className="item-text label color-blue-dark">
        Musculatura facial
      </Typography>
      <Stack className="container-chip">
        {data?.musculaturaFacial.map(
          (value, index) =>
            value !== "" && <Chip className="chip" label={value} key={index} />
        )}
      </Stack>
      <Stack mt="15px">
        <Item label="Masseter" text={data.masseter} />
      </Stack>

      <Typography className="section-title">Língua</Typography>
      <Stack className="template-grid column-3">
        <Item label="Língua (Movimentação)" text={data.linguaMovimentacao} />
        <Item label="Língua (Atrofia)" text={data.linguaAtrofia} />
        <Item label="Língua (Fasciculação)" text={data.linguaFasciculacao} />
      </Stack>
      <Stack mt="15px">
        <Item label="Velo Palatino (Movimentação)" text={data.veloPalatino} />
      </Stack>
      <Stack mt="15px" className="template-grid column-3">
        <Item label="Disartria" text={data.disartria} />
        <Item label="Anartria" text={data.anartria} />
        <Stack></Stack>
      </Stack>
    </Stack>
  );
}
